export const DADATA_API_KEY = process.env.REACT_APP_DADATA_API_KEY;
export const MIXPANEL_API_KEY = process.env.REACT_APP_MIXPANEL_API_KEY;